import Home from './routes/Home.svelte';
import Match from './routes/Match.svelte';
import NewMatch from './routes/NewMatch.svelte';
import MatchList from './routes/MatchList.svelte';
import ShareView from './routes/ShareView.svelte';

const routes = {
  '/': Home,
  '/new-match': NewMatch,
  '/match-list/:target?': MatchList,
  '/match/:id/:view?': Match,
  '/share/:token': ShareView,
  '*': Home,
};

export default routes; 